import { useEffect } from 'react';

export default function useReplaceUrl(newUrl) {
  useEffect(() => {
    if (newUrl) {
      window.history.replaceState(null, '', newUrl);
    }
  }, [newUrl]);
}